var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHealth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 130 130",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:currentColor;stroke-miterlimit:10;stroke-width:2px;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "health") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Health"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "52.82 53.88 52.82 109.41 30.49 109.41 30.49 20.59 52.82 20.59 52.82 44.45"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 65,
    cy: 30.74,
    rx: 7.11,
    ry: 7.61
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "77.18 44.45 77.18 20.59 99.51 20.59 99.51 109.41 77.18 109.41 77.18 53.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "77.18 105.35 77.18 53.96 96.47 44.45 33.53 44.45 52.82 53.88 52.82 103.32 65 70.84 77.18 105.35"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealth);
export default __webpack_public_path__ + "static/media/health.1d7dfe2a4b2613ce18a6f82013e4ed6a.svg";
export { ForwardRef as ReactComponent };